<template>
  <div>
    <el-breadcrumb separator-class="el-icon-arrow-right">
      <el-breadcrumb-item>人员管理</el-breadcrumb-item>
      <el-breadcrumb-item>人员列表</el-breadcrumb-item>
    </el-breadcrumb>

    <div class="row">
      <div class="col-sm-12">
        <div class="tab-base">
          <ul class="nav nav-tabs">
            <li class="active">
              <a data-toggle="tab" href="#demo-lft-tab-1">服务人员列表</a>
            </li>
            <li>
              <a data-toggle="tab" href="#demo-lft-tab-2">组织架构</a>
            </li>
          </ul>

          <div class="tab-content">
            <div id="demo-lft-tab-1" class="tab-pane fade active in">
              <div class="row">
                <div class="col-sm-6">
                  <div class="form-group">
                    <div class="col-sm-6">
                      <el-input
                        v-model="filter.name"
                        size="small"
                        placeholder="搜索姓名、电话号码"
                        clearable
                      ></el-input>
                    </div>
                    <!-- <div class="col-sm-6">
                      <el-button
                        type="primary"
                        size="small"
                        @click="
                          filter.page = 1
                          getData(false)
                        "
                        >搜索</el-button
                      >
                      <el-button
                        type="default"
                        size="small"
                        @click="getData(true)"
                        >重置</el-button
                      >
                    </div> -->
                  </div>
                </div>
              </div>
              <mytable :list="tablUsers" class="m-t-20"></mytable>
            </div>
            <div id="demo-lft-tab-2" class="tab-pane fade">
              <div class="chart-container">
                <!-- {{ treeData.length }} -->
                <div
                  :id="`chart${n}`"
                  :key="n"
                  v-for="n in treeData.length"
                  class="orgChart"
                ></div>
              </div>
              <div class="user-list m-t-40">
                <ul
                  v-for="user in treeData"
                  class="org"
                  :key="user.id"
                  style="display: none"
                >
                  <li>
                    {{ user.name }}（{{ ReportUserLevelMap[user.level] }}）<i
                      class="btn-label ion-plus-circled"
                    ></i>
                    <ul>
                      <li v-for="c in user.children" :key="c.id">
                        {{ c.name }}（{{ ReportUserLevelMap[c.level] }}）<i
                          class="btn-label ion-plus-circled"
                        ></i>
                        <ul>
                          <li v-for="cc in c.children" :key="cc.id">
                            {{ cc.name }}（{{ ReportUserLevelMap[cc.level] }}）
                            <i class="btn-label ion-plus-circled"></i>
                            <ul>
                              <li v-for="ccc in cc.children" :key="ccc.id">
                                {{ ccc.name }}（{{
                                  ReportUserLevelMap[ccc.level]
                                }}）
                                <i class="btn-label ion-plus-circled"></i>
                              </li>
                            </ul>
                          </li>
                        </ul>
                      </li>
                    </ul>
                  </li>
                </ul>
                <span class="text-bold">未设置层级关系人员：</span>
                <span v-for="(user, index) in noLevelUsers" :key="user.id"
                  >{{ index != 0 ? '、' : '' }}{{ user.name }}</span
                >
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import mytable from './_table.vue'
import { ReportUserLevelMap } from '../../../config/global'

import { reportUserList } from '../../../service/getData'

import $ from 'jquery'
import mixin from '@/plugins/jquery.jOrgChart.js'
import '@/plugins/jquery.jOrgChart.css'

export default {
  components: {
    mytable,
  },
  data() {
    return {
      ReportUserLevelMap,
      users: [],
      filter: {
        page: 1,
        size: 100,
        name: '',
      },
    }
  },
  computed: {
    tablUsers() {
      return this.users.filter(
        (item) =>
          !this.filter.name ||
          item.name.toLowerCase().includes(this.filter.name.toLowerCase()) ||
          item.phone_number.includes(this.filter.name)
      )
    },
    treeData() {
      return this.getTreeData(
        this.users.filter(
          (item) =>
            item.parent_id ||
            (item.subordinate_names && item.subordinate_names.length > 0)
        ),
        0
      )
    },

    noLevelUsers() {
      return this.users.filter(
        (item) =>
          !item.parent_id &&
          (!item.subordinate_names || item.subordinate_names.length == 0)
      )
    },
  },
  mounted() {
    this.$nextTick(() => {
      setTimeout(() => {
        $(function () {
          $('.org').each(function (index) {
            $(this).jOrgChart({
              chartElement: `#chart${index + 1}`,
            })
          })
        })
      }, 1000)
    })
  },
  created() {
    if (this.$route.query.filter) {
      this.filter = JSON.parse(this.$route.query.filter)
    }
    this.getData()
  },
  methods: {
    async getData(reset = false) {
      if (reset) {
        this.filter.name = ''
        this.filter.page = 1
      }
      this.$router.replace({
        query: { filter: JSON.stringify(this.filter) },
      })

      let params = this.clone(this.filter)
      params.page -= 1

      let res = await reportUserList(params)
      this.users = res.data.list
    },

    getTreeData(arr, parentId) {
      function loop(parentId) {
        let res = []
        for (let i = 0; i < arr.length; i++) {
          let item = arr[i]

          if (item.parent_id !== parentId) {
            continue
          }

          item.children = loop(item.id)
          res.push(item)
        }
        return res
      }
      return loop(parentId)
    },
  },
}
</script>